import {
  ADD_GEOHASH_GROUP,
  ADD_TUPLE_LIST,
  REMOVE_GEOHASH_GROUP,
} from 'actions/actionTypes';

const defaultState = {
  geohashGroups: [],
  tupleLists: [],
  nextColorIndex: 0,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADD_GEOHASH_GROUP:
      return {
        ...state,
        geohashGroups: [
          ...state.geohashGroups,
          {
            id: Date.now(),
            name: action.payload.name,
            list: action.payload.list
              .split(',')
              .map((item) => item.trim())
              .filter((item) => item.length > 0),
            color: action.payload.color,
            heightFromGround: action.payload.heightFromGround,
            cuboidHeight: action.payload.cuboidHeight,
          },
        ],
        nextColorIndex: state.nextColorIndex + 1,
      };
    case ADD_TUPLE_LIST:
      return {
        ...state,
        tupleLists: [
          ...state.tupleLists,
          {
            id: Date.now(),
            name: action.payload.name,
            tupleList: action.payload.tupleList
              .split(',')
              .map((item) => item.trim())
              .filter((item) => item.length > 0),
          },
        ],
      }
    case REMOVE_GEOHASH_GROUP:
      return {
        ...state,
        geohashGroups: state.geohashGroups.filter(
          (group) => group.id !== action.payload,
        ),
      };
    default:
      return state;
  }
};
